import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { InvestorTypeInstitutionsModel } from './investor-type-institutions.model';

export class InvestorTypeInstitutionsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'InvestorTypeInstitutionsConfiguration';
  nodataLocalizationKeyName = 'investorTypeInstitutions';
  readonly reportSection = ReportSection.InvestorTypeInstitutions;
  readonly applicableReportTypes = [ReportType.OwnershipAnalyticsReport];
  readonly reportViewModelSections = [ReportViewModelSection.OwnershipAnalyticsReport_InvestorTypeInstitutions];
  readonly minSize = 2;
  readonly maxSize = 4;
  readonly defaultSize = 4;
  readonly availableDataSections = [];

  get name(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'investorTypeInstitutions';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'Investor Type';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface InvestorTypeInstitutionsData {
  [ReportViewModelSection.OwnershipAnalyticsReport_InvestorTypeInstitutions]: InvestorTypeInstitutionsModel;
}
